[
  {
    "key": "Page",
    "text": "Page",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة الاستبيانات"
      },
      {
        "language": "FR",
        "text": "Liste de Enquętes"
      }
    ]
  }
]
